module.exports = __webpack_public_path__ + "static/img/kjfw_banner_01.39256cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kjfw_banner_01.png
// module id = RYww
// module chunks = 1